import "./index.css";
import React, { useMemo } from "react";

interface TypeMultipleChoiceProps<T = React.Key> {
  /**
   * @name options 多选项
   */
  options?: Record<"value" | "label", React.Key>[];
  onChange?(value: T[]): void;
  value?: T[];
}

/**
 * @name MultipleChoice 多选
 * @description 受控
 */
const MultipleChoice: React.FC<TypeMultipleChoiceProps> = ({
  options,
  onChange,
  value = [],
  ...props
}) => {
  const SET = useMemo(() => new Set(value), [value]);

  function onClick(val: React.Key) {
    const i = value.indexOf(val);
    if (~i) value.splice(i, 1);
    else value.push(val);
    onChange?.([...value]);
  }

  return (
    <ol {...props} className="website-multiple-choice">
      {options?.map((v) => (
        <li
          key={v.value}
          onClick={() => onClick(v.value)}
          className={SET.has(v.value) ? "website-multiple-choice-selected" : ""}
        >
          <span className="website-multiple-choice-check">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 13 9"
              fill="currentColor"
            >
              <rect
                y="3.51196"
                width="2"
                height="7.09402"
                transform="rotate(-45 0 3.51196)"
                fill="currentColor"
              />
              <rect
                x="10.7168"
                width="2"
                height="10.0613"
                transform="rotate(45 10.7168 0)"
                fill="currentColor"
              />
            </svg>
          </span>
          <span>{v.label}</span>
        </li>
      ))}
    </ol>
  );
};

export default MultipleChoice;
